export const categories = [
  { id: 'all', name: 'All', slug: '' },
  { id: 'ai-native', name: 'AI-Native Applications', slug: 'ai-native-applications' },
  { id: 'productivity', name: 'Productivity & Personal Systems', slug: 'productivity-and-personal-systems' },
  { id: 'business', name: 'Business Operations & SaaS', slug: 'business-operations-and-saas' },
  { id: 'developer', name: 'Developer & Builder Tools', slug: 'developer-and-builder-tools' },
  { id: 'automation', name: 'Automation & Orchestration', slug: 'automation-and-orchestration' },
  { id: 'data', name: 'Data, Analytics & Insights', slug: 'data-analytics-and-insights' },
  { id: 'marketing', name: 'Marketing, Growth & Distribution', slug: 'marketing-growth-and-distribution' },
  { id: 'content', name: 'Content, Creator & Publishing', slug: 'content-creator-and-publishing' },
  { id: 'consumer', name: 'Consumer, Lifestyle & Utility', slug: 'consumer-lifestyle-and-utility' },
  { id: 'marketplaces', name: 'Marketplaces, Directories & Discovery', slug: 'marketplaces-directories-and-discovery' },
  { id: 'identity', name: 'Identity, Payments & Trust', slug: 'identity-payments-and-trust' },
  { id: 'design', name: 'Design, UI & Building Blocks', slug: 'design-ui-and-building-blocks' },
  { id: 'education', name: 'Education & Learning', slug: 'education-and-learning' },
  { id: 'experimental', name: 'Experimental, Indie & Fun', slug: 'experimental-indie-and-fun' }
];

export const startups = [
  {
    id: 1,
    name: 'Base',
    slug: 'base44-com',
    description: 'From idea to live app in minutes, Base gives you the tools to launch fully-functional apps - no code, no setup, no hassle.',
    image: 'https://ozaezmywwxodlkbrnpfv.supabase.co/storage/v1/object/public/vs_screenshots/base44-com.png',
    country: '🇺🇸',
    team: '44Team',
    rating: 4,
    category: 'AI Agents',
    categorySlug: 'ai-native-applications'
  },
  {
    id: 2,
    name: 'Anything',
    slug: 'anything-com',
    description: 'Anything is your AI agent for turning ideas into apps, enabling you to build sites, tools, and products just by describing what you want.',
    image: 'https://ozaezmywwxodlkbrnpfv.supabase.co/storage/v1/object/public/vs_screenshots/anything-com.png',
    country: '🇺🇸',
    team: 'Anything Group',
    rating: 4,
    category: 'AI Agents',
    categorySlug: 'ai-native-applications'
  },
  {
    id: 3,
    name: 'Rosebud AI Vibe Coder',
    slug: 'lab-rosebud-ai',
    description: 'Create immersive games effortlessly with our Vibe Coding Tool, designed for non-developers to build and deploy in any browser.',
    image: 'https://ozaezmywwxodlkbrnpfv.supabase.co/storage/v1/object/public/vs_screenshots/lab-rosebud-ai.png',
    country: '🇹🇭',
    team: 'Supaporn Iyot',
    rating: 3,
    category: 'AI Coding Assistants',
    categorySlug: 'developer-and-builder-tools'
  },
  {
    id: 4,
    name: 'PetPal Passport',
    slug: 'petpalpassport-com',
    description: 'A complete digital health passport for dogs and cats, managing vaccinations, treatments, and documents all in one place.',
    image: 'https://ozaezmywwxodlkbrnpfv.supabase.co/storage/v1/object/public/vs_screenshots/petpalpassport-com.png',
    country: '🇨🇿',
    team: 'Vaclav Kocum',
    rating: 4,
    category: 'Side Projects',
    categorySlug: 'experimental-indie-and-fun'
  },
  {
    id: 5,
    name: 'Consensus',
    slug: 'consensus-app',
    description: 'Turn collective intelligence into clear, confident decisions.',
    image: 'https://ozaezmywwxodlkbrnpfv.supabase.co/storage/v1/object/public/vs_screenshots/consensus-app.png',
    country: '🇬🇧',
    team: 'ConcensusTeam',
    rating: 5,
    category: 'AI Assistants (Personal)',
    categorySlug: 'productivity-and-personal-systems'
  },
  {
    id: 6,
    name: 'ResearchRabbit',
    slug: 'researchrabbit-ai',
    description: 'Keep your literature search quick, easy, and organized while diving down the rabbit hole of discovery.',
    image: 'https://ozaezmywwxodlkbrnpfv.supabase.co/storage/v1/object/public/vs_screenshots/researchrabbit-ai.png',
    country: '🇺🇸',
    team: 'Hunter Balmores',
    rating: 5,
    category: 'AI Research Tools',
    categorySlug: 'data-analytics-and-insights'
  },
  {
    id: 7,
    name: 'remove.bg',
    slug: 'remove-bg',
    description: 'Remove image backgrounds automatically in 5 seconds with just one click, saving you time and delivering professional results.',
    image: 'https://ozaezmywwxodlkbrnpfv.supabase.co/storage/v1/object/public/vs_screenshots/remove-bg.png',
    country: '🇦🇺',
    team: 'Canva',
    rating: 5,
    category: 'AI Image Generation',
    categorySlug: 'content-creator-and-publishing'
  },
  {
    id: 8,
    name: 'Emailnator',
    slug: 'emailnator-com',
    description: 'The most advanced temporary gmail service on the web to keep spam out of your mail and stay safe.',
    image: 'https://ozaezmywwxodlkbrnpfv.supabase.co/storage/v1/object/public/vs_screenshots/emailnator-com.png',
    country: '🇨🇳',
    team: 'Xi Weng',
    rating: 4,
    category: 'Cold Email Tools',
    categorySlug: 'marketing-growth-and-distribution'
  },
  {
    id: 9,
    name: 'Viola App',
    slug: 'viola-land',
    description: 'Cultivating wellbeing with gratitude, motivation, mindfulness tracking, and more.',
    image: 'https://ozaezmywwxodlkbrnpfv.supabase.co/storage/v1/object/public/vs_screenshots/viola-land.png',
    country: '🇺🇸',
    team: 'Edward Whitehead',
    rating: 4,
    category: 'Mental Health Tools',
    categorySlug: 'consumer-lifestyle-and-utility'
  },
  {
    id: 10,
    name: 'Speaking Coach Pro',
    slug: 'speakingcoachpro-app',
    description: 'Become a confident, dynamic speaker',
    image: 'https://ozaezmywwxodlkbrnpfv.supabase.co/storage/v1/object/public/vs_screenshots/speakingcoachpro-app.png',
    country: '🇵🇭',
    team: 'Roger Banat',
    rating: 4,
    category: 'AI Assistants (Personal)',
    categorySlug: 'productivity-and-personal-systems'
  },
  {
    id: 11,
    name: 'WikiLearn Studio',
    slug: 'wiki-paxgaia-org',
    description: 'Turn any Wikipedia article into an interactive learning experience with AI-enhanced narration, ambient audio, and visual storytelling.',
    image: 'https://ozaezmywwxodlkbrnpfv.supabase.co/storage/v1/object/public/vs_screenshots/wiki-paxgaia-org.jpeg',
    country: '🇺🇸',
    team: 'Jim Walker',
    rating: 4,
    category: 'AI Agents',
    categorySlug: 'ai-native-applications'
  },
  {
    id: 12,
    name: 'Komendly',
    slug: 'komendly-com',
    description: 'Turn your 5-star Google reviews into professional video testimonials with AI avatars—no filming or actors needed.',
    image: 'https://ozaezmywwxodlkbrnpfv.supabase.co/storage/v1/object/public/vs_screenshots/komendly-com.png',
    country: '🇺🇸',
    team: 'Nolan Grout',
    rating: 4,
    category: 'AI Video Generation',
    categorySlug: 'content-creator-and-publishing'
  },
  {
    id: 13,
    name: 'Vedbod',
    slug: 'vedbod-no',
    description: "Norway's new marketplace for firewood, where you can find local firewood sellers, check prices.",
    image: 'https://ozaezmywwxodlkbrnpfv.supabase.co/storage/v1/object/public/vs_screenshots/vedbod-no.png',
    country: '🇳🇴',
    team: 'Daniel Tilrem',
    rating: 4,
    category: 'Shopping Tools',
    categorySlug: 'marketplaces-directories-and-discovery'
  },
  {
    id: 14,
    name: 'SimulTranslate',
    slug: 'simultranslate-com-tr',
    description: 'Get instant translation in over 100 languages with real-time AI screen translation for games.',
    image: 'https://ozaezmywwxodlkbrnpfv.supabase.co/storage/v1/object/public/vs_screenshots/simultranslate-com-tr.png',
    country: '🇹🇷',
    team: 'Simul',
    rating: 4,
    category: 'AI Translation Tools',
    categorySlug: 'ai-native-applications'
  },
  {
    id: 15,
    name: 'Dola AI',
    slug: 'dola-com',
    description: 'Dola AI is your AI chat assistant for intelligent conversations, writing, translation and programming.',
    image: 'https://ozaezmywwxodlkbrnpfv.supabase.co/storage/v1/object/public/vs_screenshots/dola-com.png',
    country: '🇨🇳',
    team: 'Spring SG',
    rating: 4,
    category: 'AI Chatbots',
    categorySlug: 'ai-native-applications'
  },
  {
    id: 16,
    name: 'AppScan.dev',
    slug: 'appscan-dev',
    description: 'The easiest way to find and fix security vulnerabilities in your web applications and code repositories.',
    image: 'https://ozaezmywwxodlkbrnpfv.supabase.co/storage/v1/object/public/vs_screenshots/appscan-dev.png',
    country: '🇵🇰',
    team: 'AppScanTeam',
    rating: 11,
    category: 'AI Agents',
    categorySlug: 'developer-and-builder-tools'
  },
  {
    id: 17,
    name: 'Fliki',
    slug: 'fliki-ai',
    description: 'Transform your ideas to videos effortlessly with the best AI Video Generator, featuring user-friendly text-to-video editing and realistic voiceovers.',
    image: 'https://ozaezmywwxodlkbrnpfv.supabase.co/storage/v1/object/public/vs_screenshots/fliki-ai.png',
    country: '🇩🇰',
    team: 'Fliki',
    rating: 6,
    category: 'AI Video Generation',
    categorySlug: 'content-creator-and-publishing'
  },
  {
    id: 18,
    name: 'Blieve AI',
    slug: 'blieve-ai',
    description: 'Why choose one AI tool when you can have them all at Blieve AI Suite to increase productivity and creativity in your design workflow.',
    image: 'https://ozaezmywwxodlkbrnpfv.supabase.co/storage/v1/object/public/vs_screenshots/blieve-ai.png',
    country: '🇦🇪',
    team: 'Blieve',
    rating: 6,
    category: 'AI Image Generation',
    categorySlug: 'content-creator-and-publishing'
  },
  {
    id: 19,
    name: 'Humata',
    slug: 'humata-ai',
    description: 'Humata is an AI agent that turns your documents into a fast, intelligent knowledge base for instant analysis, insights, and answers.',
    image: 'https://ozaezmywwxodlkbrnpfv.supabase.co/storage/v1/object/public/vs_screenshots/humata-ai.png',
    country: '🇺🇸',
    team: 'Humata',
    rating: 5,
    category: 'AI Agents',
    categorySlug: 'ai-native-applications'
  },
  {
    id: 20,
    name: 'Marblism',
    slug: 'marblism-com',
    description: 'AI Employees to scale your business with specialized roles like receptionists, SEO experts, and more.',
    image: 'https://ozaezmywwxodlkbrnpfv.supabase.co/storage/v1/object/public/vs_screenshots/marblism-com.png',
    country: '🇨🇦',
    team: 'Marblism',
    rating: 6,
    category: 'AI Assistants (Business)',
    categorySlug: 'business-operations-and-saas'
  },
  {
    id: 21,
    name: 'Ryne AI',
    slug: 'ryne-ai',
    description: 'Transform AI text with Ryne\'s AI Humanizer to create natural writing that passes detectors like Turnitin.',
    image: 'https://ozaezmywwxodlkbrnpfv.supabase.co/storage/v1/object/public/vs_screenshots/ryne-ai.png',
    country: '🇬🇧',
    team: 'Ryne',
    rating: 6,
    category: 'AI Writing Tools',
    categorySlug: 'content-creator-and-publishing'
  },
  {
    id: 22,
    name: 'ReVanced (Reborn)',
    slug: 'revanced-app',
    description: 'Customize your mobile experience through ReVanced by applying patches to your applications.',
    image: 'https://ozaezmywwxodlkbrnpfv.supabase.co/storage/v1/object/public/vs_screenshots/revanced-app.png',
    country: '🇹🇼',
    team: 'Revanced',
    rating: 8,
    category: 'Uncategorized',
    categorySlug: 'experimental-indie-and-fun'
  },
  {
    id: 23,
    name: 'Floptropica',
    slug: 'floptropica-com',
    description: 'Your one-stop hub for (fantasy)digital, unique merchandise, and community engagement in Floptropica.',
    image: 'https://ozaezmywwxodlkbrnpfv.supabase.co/storage/v1/object/public/vs_screenshots/floptropica-com.png',
    country: '🇨🇳',
    team: 'Deborah Ali-Williams',
    rating: 7,
    category: 'Multi-Agent Systems',
    categorySlug: 'automation-and-orchestration'
  },
  {
    id: 24,
    name: 'NS Rule 34',
    slug: 'nsfwr34-com',
    description: 'Best 3D animated video site featuring Rule 34 cartoons and anime.',
    image: 'https://ozaezmywwxodlkbrnpfv.supabase.co/storage/v1/object/public/vs_screenshots/nsfwr34-com.png',
    country: '🇯🇵',
    team: 'LoverDev',
    rating: 44,
    category: 'Uncategorized',
    categorySlug: 'experimental-indie-and-fun'
  }
];
